import { defineStyle } from "@chakra-ui/react";
import SuccessBackground from "../../../assets/svgs/successBackground.svg";

export const SuccessStyles = () => {
  return {
    mainContainer: defineStyle({
      position: "fixed",
      top: 0,
      left: 0,
      zIndex: 9999,
      backgroundImage: `url(${SuccessBackground})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      width: "100%",
      height: "100vh",
      overflow: "auto",
    }),
    successContainer: defineStyle({
      position: "absolute",
      display: "grid",
      gridTemplateColumns: "repeat(12,1fr)",
      gap: "1.5rem",
      height: "100%",
      width: "100%",
      marginX: { base: 0, lg: "2.5rem" },
      marginBottom: "60px",
    }),
    successSubContainer: defineStyle({
      gridColumn: { base: "2/12", md: "2/12", lg: "3/11" },
      bgColor: "white",
      marginY: "150px",
      paddingBottom: "40px",
      minHeight: "700px",
      minWidth: "350px",
      borderRadius: "20px",
      width: "100%",
      boxShadow: "0px 0px 63px 0px #0000001A",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    }),
    lottieContainer: defineStyle({
      width: { base: "70%", md: "60%" },
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      // bgColor: "pink",
      // marginTop: "92px",
    }),
    appreciationTitleContainer: defineStyle({
      marginTop: "36px",
      fontFamily: "Poppins",
      fontWeight: "600",
      fontSize: { base: "30px", md: "36px", lg: "42px" },
      lineHeight: { base: "36px", md: "40px", lg: "48px" },
      textAlign: "center",
      color: "#FF8D77",
      // bgColor: "yellow",
    }),
    appreciationDescriptionContainer: defineStyle({
      marginTop: "20px",
      fontFamily: "Poppins, Mobile/2xl_semibold",
      fontWeight: "600",
      fontSize: { base: "16px", md: "20px", lg: "24px" },
      lineHeight: { base: "20px", md: "24px", lg: "28px" },
      textAlign: "center",
      color: "#6D6BAE",
      // bgColor: "blue",
      paddingX: { base: "40px", md: "60px", lg: "80px" },
    }),
    resultContainer: defineStyle({
      display: "flex",
      gap: "30px",
      marginTop: "24px",
    }),
    wrongButton: defineStyle({
      padding: "4px 12px",
      gap: "4px",
      borderRadius: "12px",
      backgroundColor: "#FF8D77",
    }),
    correctButton: defineStyle({
      padding: "4px 12px",
      gap: "4px",
      borderRadius: "12px",
      backgroundColor: "#7ABC40",
    }),
    buttonContainer: defineStyle({
      marginTop: "40px",
      marginBottom: "84px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "16px",
      width: "100%",
    }),
  };
};
